import { useState } from "react";

export default function OpportunityTableSearchBar({ onSearch }) {
  const [searchTerm, setSearchTerm] = useState("");
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    onSearch(searchTerm);
  }

  return (
    <form onSubmit={handleSubmit} className="relative w-[400px]">
        <div className="absolute inset-y-0 left-3 flex items-center">
            <button type="submit" className="hover:text-gray-600 focus:outline-none">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 text-gray-400">
                <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
                </svg>
            </button>
        </div>
        <input
            type="text"
            placeholder="Search"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full h-[42px] pl-10 pr-4 py-1 gap-2 rounded-full border border-[#64748B] bg-[#F8FAFC]"
        />
    </form>
  );
}